import { createSlice } from "@reduxjs/toolkit";
import { IStore, UserRole } from "helpers";

export const authReducer = createSlice({
  name: "auth store",
  initialState: {
    authenticated: false,
    accessToken: "",
    roleTemporary: UserRole.Farmer,
    cmsUserId: "",
    cmsUserPermission: [],
    producerId: '',
    requestorproducerid: null,
    requestoruserid: null,
    isSwitchAccount: false,
    // logoutConfirmationClicked: false
  },
  reducers: {
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    setTemporaryUser: (state, action) => {
      localStorage.setItem("temporaryUser", action.payload);
    },
    setAuthState: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.authenticated = true;
      state.roleTemporary = action.payload.roleTemporary;
      state.cmsUserPermission = action.payload.cmsUserPermission;
      state.cmsUserId = action.payload.cmsUserId;
      state.producerId = action?.payload?.producerId;
      state.requestorproducerid = action?.payload?.requestorproducerid;
      state.requestoruserid = action?.payload?.requestoruserid;
      state.isSwitchAccount = action?.payload?.requestoruserid?.length > 0;
    },
  },
});

export const { setAccessToken, setTemporaryUser, setAuthState } = authReducer.actions;

export const getAuthenticated = (state: IStore) => state.auth.authenticated;
export const getAccessToken = (state: IStore) => state.auth.accessToken;
export const getTemporaryUser = (state: IStore) => {
  return (localStorage.getItem("temporaryUser") ?? "") === "true" || false;
};
export const getCmsUserId = (state: IStore) => state.auth.cmsUserId;
export const getRoleTemporary = (state: IStore) => state.auth.roleTemporary;
export const getPermissionTemporary = (state: IStore) => state.auth.cmsUserPermission;
export const getAuth = (state: IStore) => state.auth;
export default authReducer.reducer;